<template>
    <div class="slider slider--stats scroll-reveal animate__animated" data-animation="bounceInRight">
        <h2 class="slider__title scroll-reveal animate__animated" data-animation="bounceInUp">{{ slideTitle }}</h2>
        <p class="slider__text scroll-reveal animate__animated" data-animation="bounceInUp">{{ $t('game-results.price-text') }}</p>

        <vueper-slides @slide="updateSlideInfo($event)" :infinite="false" :disableArrowsOnEdges="true" :bullets="false" :gap="3" :visible-slides="3" :slideMultiple="3" :breakpoints="{1240: {visibleSlides: 1, slideMultiple: 1}}" class="no-shadow">
            <vueper-slide v-for="(item, index) in allSlides" :key="index">
                <template #content>
                    <div class="slider__item">
                        <h3 class="slider__subtitle">{{ $t(`game-results.after-building.${item.monthlyResourceExpense.resourceType}`) }}</h3>
                        <ul class="slider__list">
                            <li class="slider__list-item">
                                <span>{{ $t('game-results.your-house-text') }}</span>
                                <span>{{ formatNumber(item.buildExpense) }}</span>
                            </li>
                            <li class="slider__list-item">
                                <span>{{ $t('game-results.average-text') }}</span>
                                <span>{{ formatNumber(item.regionAverageExpense) }}</span>
                            </li>
                            <li :class="['slider__list-item', {'slider__list-item--negative': !checkNumber(item.costDifference), 'slider__list-item--positive': checkNumber(item.costDifference) }]">
                                <span>{{ $t('game-results.difference-text') }}</span>
                                <span>{{ formatNumber(item.costDifference) }}</span>
                            </li>
                        </ul>
                        <div class="slider__message" v-if="item.savingsMessage">
                            <template v-if="item.savingsMessage.icon">
                                <img :src="`${apiUri}${item.savingsMessage.icon}`" :alt="item.savingsMessage.message" class="slider__icon">
                            </template>
                            <div>{{ item.savingsMessage.message }}</div>
                        </div>
                    </div>
                </template>
            </vueper-slide>

            <template #arrow-right>
                <div class="btn btn--option">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0001 7.99991L11.0001 15.9999L19.0001 23.9999" stroke="#F88C50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </template>
            <template #arrow-left>
                <div class="btn btn--option">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.0001 7.99991L11.0001 15.9999L19.0001 23.9999" stroke="#F88C50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </template>
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
    name: 'ResultsAfterBuilding',
    components: {
        VueperSlides,
        VueperSlide
    },
    inject: ['buildReport', 'scrollTrigger', 'addObserver'],
    data() {
        return {
            report: this.buildReport,
            currentSlideTitle: null,
        }
    },
    computed: {
        electricityExpenses() {
            return this.report.ElectricityExpenses;
        },
        waterExpenses() {
            return this.report.WaterExpenses;
        },
        gasExpenses() {
            return this.report.GasExpenses;
        },
        timePeriods() {
            let timePeriods = [];

            this.electricityExpenses.forEach(expense => {
                timePeriods.push(expense.timePeriod);
            });

            return timePeriods;
        },
        slideTitle() {
            if (this.currentSlideTitle) {
                return this.currentSlideTitle;
            } else {
                return this.$t(`game-results.after-building.${this.timePeriods[0]}`);
            }
        },
        allSlides() {
            let allSlides = [];

            this.timePeriods.forEach(period => {
                this.electricityExpenses.forEach(expense => {
                    if (expense.timePeriod == period) {
                        allSlides.push(expense);
                    }
                });

                this.waterExpenses.forEach(expense => {
                    if (expense.timePeriod == period) {
                        allSlides.push(expense);
                    }
                });

                this.gasExpenses.forEach(expense => {
                    if (expense.timePeriod == period) {
                        allSlides.push(expense);
                    }
                });
            });

            return allSlides;
        },
        apiUri() {
            return process.env.VUE_APP_APOLLO_API_URI;
        }
    },
    methods: {
        updateSlideInfo(params) {
            this.currentSlide = params.currentSlide.index;

            if (params.currentSlide.index <= 2) {
                this.currentSlideTitle = this.$t(`game-results.after-building.${this.timePeriods[0]}`);
            } else if (params.currentSlide.index >= 3 && params.currentSlide.index <= 5) {
                this.currentSlideTitle = this.$t(`game-results.after-building.${this.timePeriods[1]}`);
            } else if (params.currentSlide.index >= 6 && params.currentSlide.index <= 8) {
                this.currentSlideTitle = this.$t(`game-results.after-building.${this.timePeriods[2]}`);
            } else if (params.currentSlide.index >= 9 && params.currentSlide.index <= 11) {
                this.currentSlideTitle = this.$t(`game-results.after-building.${this.timePeriods[3]}`);
            } else {
                this.currentSlideTitle = null;
            }
        },
        formatNumber(num) {
            return Math.abs(Math.round((num + Number.EPSILON) * 100) / 100);
        },
        checkNumber(num) {
            let rounded = Math.round((num + Number.EPSILON) * 100) / 100;

            if (rounded < 0) {
                return false;
            } else {
                return true;
            }
        }
    },
    mounted() {
        this.scrollTrigger('.scroll-reveal', {
            rootMargin: '-50px'
        });
    }
}
</script>
